import React, { useState } from 'react';
import EventProvider from 'context/events/Event';
import TagsProvider from 'context/events/Tags';
import EventFilters from 'modules/dashboard/events/EventFilters';
import MainContent from 'modules/dashboard/events/MainContent';
import RightSlotEvent from 'modules/dashboard/events/RightSlotEvent';
import DetailVisibleProvider from 'context/dash/DetailVisible';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import ShowAllEventsProvider from 'context/dash/ShowAllEvents';
import EventDetailTabProvider from 'context/dash/EventDetailTab';
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash';
import { useUser } from 'context/user/User';
import BatchesProvider from 'context/checkout/Batch';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';

export default function DashEvents() {
    const [createEventClick, setCreateEventClick] = useState(0);
    const [createDraftClick, setCreateDraftClick] = useState(0);

    return (
        // <UserProvider>
        <BatchesProvider>
            <DetailVisibleProvider>
                <EventProvider>
                    <BackButtonCollapseDashProvider>
                        <EventDetailTabProvider>
                            <TagsProvider>
                            <ShowAllEventsProvider>

                                    <DashContainer title={'Eventos'} rightSlot={RightSlotContent}>
                                        <MainContent
                                            createEventClick={createEventClick} 
                                            createDraftClick={createDraftClick} 
                                            setCreateDraftClick={setCreateDraftClick}
                                        />
                                    </DashContainer>

                                </ShowAllEventsProvider>
                            </TagsProvider>
                        </EventDetailTabProvider>
                    </BackButtonCollapseDashProvider>
                </EventProvider>
            </DetailVisibleProvider>
        </BatchesProvider>
        // </UserProvider>
    );

    function RightSlotContent() {
        let createEventVisible = false;
        const { user } = useUser();

        const isProducer = user?.role?.id == import.meta.env.VITE_PRODUCER_ROLE_ID;
        const isEstablishment = user?.role?.id == import.meta.env.VITE_ESTABLISHMENT_ROLE_ID;
        const isAdmin = user?.role?.id == import.meta.env.VITE_ADMIN_ROLE_ID;

        if (isEstablishment && user?.establishments?.length) {
            createEventVisible = true;
        }

        if (isProducer || isAdmin) {
            createEventVisible = true;
        }


        return (
            createEventVisible && (
                <RightSlotWrapper>
                    <EventFilters hasEvents={createEventVisible} />
                    <RightSlotEvent
                        onCreateEventClick={() => setCreateEventClick(createEventClick + 1)}
                        onCreateDraftClick={() => setCreateDraftClick(createDraftClick + 1)}
                        hasEvents={createEventVisible}
                    />
                </RightSlotWrapper>
            )
        );
    }
}

const RightSlotWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-items: center;
        width: auto;
        gap: 0;
    }
`;
